export default "__VITE_ASSET__BdXuUXY___"